<template>
    <span>
        {{ displayedResource }}
    </span>
</template>

<script>
    import getResource from '../../Util/resources'
    
    export default {
        name: "resource-string",
        computed: {
            displayedResource(){
                return getResource(this.name);
            }
        },
        props: {
            name: {
                type: String,
                required: true
            }
        }
    }
</script>

<style scoped>

</style>
